<template>
    <label
        class="kgr-inputGroup"
        :class="{ 'kgr-inputGroup--inline': inline, 'is-invalid': isInvalid }"
    >
        <div
            v-if="label !== null && label !== ''"
            class="kgr-inputGroup__label ui-droppable"
        >
            {{ label }}
        </div>
        <input
            :type="type"
            :value="currentValue"
            :maxlength="maxLength"
            :disabled="disabled"
            class="kgr-input"
            :class="{ 'no-arrows': noArrows }"
            :pattern="pattern"
            :title="title"
            @input="onInput($event.target.value)"
            @blur="$emit('blur', $event.target.value)"
            @change="$emit('change', $event.target.value)"
            @wheel="onWheel"
        />
        <div
            v-if="error != null"
            class="kgr-color kgr-color--error"
        >
            {{ error }}<br />
        </div>
    </label>
</template>

<script>
export default {
    compatConfig: {
        MODE: 3,
    },

    props: {
        type: {
            type: String,
            required: true,
        },
        modelValue: {
            type: String,
            required: false,
        },
        value: {
            type: String,
            required: false,
        },
        error: {
            type: String,
            required: false,
            default: null,
        },
        label: {
            type: String,
            required: false,
            default: null,
        },
        maxLength: {
            type: Number,
            required: false,
        },
        inline: {
            type: Boolean,
            required: false,
            default: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        isInvalid: {
            type: Boolean,
            required: false,
            default: false,
        },
        pattern: {
            type: String,
            required: false,
            default: null,
        },
        title: {
            type: String,
            required: false,
            default: null,
        },
        noArrows: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    emits: ['update:modelValue', 'post-input', 'input', 'change', 'blur'],

    data() {
        return {
            currentValue: this.modelValue ?? this.value,
        };
    },

    watch: {
        modelValue(newValue) {
            this.currentValue = newValue;
        },

        value(newValue) {
            this.currentValue = newValue;
        },
    },

    methods: {
        onInput(value) {
            this.currentValue = value;
            this.$emit('update:modelValue', this.currentValue);

            // support legacy dependency on 'input' event
            this.$emit('input', this.currentValue);
            this.$nextTick(() => {
                this.$emit('post-input', this.currentValue);
            });
        },

        onWheel(event) {
            if (this.type === 'number' && event.currentTarget === document.activeElement) {
                event.preventDefault();
            }
        },
    },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
     /* Chrome, Safari, Edge, Opera */
input.no-arrows::-webkit-outer-spin-button,
input.no-arrows::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type='number'].no-arrows {
    -moz-appearance: textfield;
}
</style>
